export function NotFound(){
    return <div>
        <h4>404: Not Found</h4>
        <div>
            
        </div>
    </div>
}